




































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { User } from "@/components/User";
import { APP_URL } from "@/common/http";
import { createDate } from "@/common/utils";

@Component
export default class ImageArchive extends Vue {
  @Prop({
    default: null
  }) data: Object; //User

  appUrl:string = APP_URL;
  imageArchive: any[] = [];
  SelectedImageCategory:any = {}; // must initialize as {}

  get User() : User {
    return this.$store.getters.User;
  };

  get language() : string {
    return this.User.Language;
  };

  async fetchImageArchive() {
    try {
      let url = 'mis/archive/' + this.SelectedImageCategory.code
      let data = await this.User.requestResource(url);
      if (data) {
        this.imageArchive = data.map((image) => {
          image.active = false;
          if (image.exif_date) {
            image.exif_date = createDate(image.exif_date);
          }
          return image;
        });
      } else {
        this.uploadImage();
      }
    } catch (error) {
    }
  };

  created() {
    if (this.data) {
      this.SelectedImageCategory = this.data;
      this.fetchImageArchive();
    }
  }

  ImageRatio(image) :number {
    if (image.active && image.width && image.height) {
      if (image.exif_orientation==3 || image.exif_orientation==6 || image.exif_orientation==8) {
        return image.height / image.width;
      } else {
        return image.width / image.height;
      }
    } else {
      return 1;
    }
  }

  HasCoordinate(image) : boolean {
    return !(image.exif_lon===undefined || image.exif_lon===null || 
            image.exif_lat===undefined || image.exif_lat===null);
  }

  showImageOnMap(image) {
    this.$emit('changeMe',{
      menu: {
        name: 'image_locate',
      },
      data: image
    });
  }

  goBack() {
    this.$emit('changeMe', {
      menu: {
        name: 'image_category',
      }
    });
  }

  uploadImage() {
    this.$emit('changeMe',{
      menu: {
        name: 'image_uploader',
      },
      data: {
        category: this.SelectedImageCategory,
        hasImage: (this.imageArchive && this.imageArchive.length>0)
      }
    });
  }

  closeMe() {
    this.$emit('closeRightToc');
  }
}
